export default "__VITE_ASSET__Dwtw564l__"